<template>
    <section class="text-gray-700 body-font overflow-hidden">
        <div class="container px-5 py-24 mx-auto" v-if="vestido != undefined && !cargando && vestido != null">
            <div class="lg:w-4/5 mx-auto flex flex-wrap">
                <img alt="ecommerce" class="h-full md:w-1/2 md:h-auto lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded" :src="vestido.link">
                <div class="md:w-1/2 lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
                    <h2 class="text-2xl md:text-5xl tracking-widest uppercase">{{vestido.name}}</h2>
                    <h1 class="text-gray-900 text-md md:text-xl title-font font-medium mb-1">{{vestido.desc}}</h1>
                    <h1 class="text-gray-900 text-md md:text-xl title-font font-bold mb-1"> Disponibles: {{vestido.cantidad}}</h1>
                    <div class="flex mb-4 ">
                        <a :href="pidelo" class="flex my-auto h-10 px-6 font-semibold rounded-md border bg-sky-500 text-secondary"><span class="my-auto">Comprar</span></a>
                        <span class="flex items-center hidden">
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 text-teal-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 text-teal-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 text-teal-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 text-teal-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 text-teal-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <span class="text-gray-600 ml-3">4 Reviews</span>
                        </span>
                        <span class="flex ml-3 pl-3 py-2 border-l-2 space-x-4">
                            <a href="http://www.instagram.com/cios_ve" class="flex">
                                <img src="@/assets/media/ig-black.svg" width="25" height="25">
                            </a>
                            <a :href="pidelo" class="flex">
                                <img src="@/assets/media/ws-black.svg" width="25" height="25">
                            </a>
                            <a href="https://www.facebook.com/Alquiler-De-Vestidos-CIOS-225566581312036/" class="flex">
                                <img src="@/assets/media/fb-black.svg" width="25" height="25">
                            </a>
                            <a href="mailto:inversionescios@gmail.com" class="flex">
                                <img src="@/assets/media/gm-black.svg" width="25" height="25">
                            </a>
                            <div v-if="false" class=" mx-1 bg-primary focus:outline-none text-secondary py-2 px-4 rounded" type="button">
                                <a :href="pidelo">Pidelo</a>
                            </div>
                        </span>
                        <!--a class="text-gray-500">
                                <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                                </svg>
                            </a>
                            <a class="ml-2 text-primary">
                                <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                                </svg>
                            </a>
                            <a class="ml-2 text-gray-500">
                                <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                                </svg>
                            </a-->
                    </div>
                    <p class="leading-relaxed hidden"><strong>Material:</strong> {{vestido.material}}</p>
                    <!--div class="flex mt-2 items-center pb-5 border-b-2 border-gray-200 mb-2">
                        <div class="flex">
                            <span class="mr-3">Color</span>
                            <button class="border-2 rounded-full w-6 h-6 focus:outline-none" ></button>
                        </div>
                        <div class="flex ml-6 items-center hidden">
                            <span class="mr-3">Size</span>
                            <div class="relative">
                                <select class="rounded border appearance-none py-2 focus:outline-none focus:border-teal-500 text-base pl-3 pr-10">
                                    <option>{{vestido.talla}}</option>
                                </select>
                                <span class="absolute right-0 top-0 h-full w-10 text-center text-gray-600 pointer-events-none flex items-center justify-center">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4" viewBox="0 0 24 24">
                                        <path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div-->
                    <div class="flex justify-start items-center space-x-2" v-if="autenticado">
                        <span class="title-font font-medium text-2xl text-gray-900 hidden "> $ 5.99 </span>
                        <button class="flex border-primary border py-2 px-6 focus:outline-none rounded" type="button" @click="isEdit = true">
                            Edit
                        </button>
                        <button class="flex text-secondary py-2 px-6 focus:outline-none rounded" style="background: #f56565" @click="isDel = true">
                            Delete
                        </button>
                        <div v-if="false" class=" mx-1 bg-primary focus:outline-none text-secondary py-2 px-4 rounded" type="button">
                            <a :href="pidelo">Pidelo</a>
                        </div>
                    </div>
                </div>
                <CardModal :showing="isEdit" v-on:close="isEdit = false">
                    <div id="form" class="w-full max-w-lg p-2 mx-auto mt-2">
                        <div class="flex flex-wrap -mx-3 mb-6">
                            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                    Nombre
                                </label>
                                <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" :placeholder="vestido.name" v-model="name">
                                <p class="text-red-500 text-xs italic">Porfavor llenar este campo.</p>
                            </div>
                            <div class="w-full md:w-1/2 px-3">
                                <label class="block uppercase tracking-wide text-xs font-bold mb-2" for="grid-zip">
                                    Cantidad
                                </label>
                                <div class="flex flex-row">
                                    <button @click="restar"><span class="material-icons my-auto p-1 text-2xl text-primary">remove_circle</span></button>
                                    <input class="appearance-none block w-16 bg-gray-200 text-gray-700 border border-gray-200 rounded my-2 py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-zip" type="number" :placeholder="calculo" v-model="numerito">
                                    <span class="my-auto text-3xl" v-if="false">{{calculo}}</span>

                                    <button @click="sumar"><span class="material-icons my-auto p-1 text-2xl text-primary">add_circle</span></button>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-3 mb-6">
                            <div class="w-full px-3">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">
                                    DescripciÓn
                                </label>
                                <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-description" type="text" :placeholder="vestido.desc" v-model="desc">
                                <p class="text-gray-600 text-xs italic">Tan extensa y loca como deseen.</p>
                            </div>
                        </div>
                        <div class="w-full md:w-1/2 mb-6 md:mb-0 md:my-2" v-if="false">
                            <label class="block uppercase tracking-wide text-xs font-bold mb-2" for="grid-zip">
                                Cantidad
                            </label>
                            
                        </div>
                        <div class="w-full md:w-1/2 -px-3 mb-6 md:my-2 " v-if="false">
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                                Talla
                            </label>
                            <select class="block appearance-none w-full bg-secondary border border-primary text-primary py-3 px-4 pr-8 rounded leading-tight  focus:outline-none focus:text-primary" v-model="talla" selected>
                                <option value="" class="text-opacity-50">Selecciona una opción</option>
                                <option>XS</option>
                                <option>S</option>
                                <option>M</option>
                                <option>L</option>
                                <option>XL</option>
                            </select>
                        </div>
                        <div class="w-full items-center justify-center flex">
                            <img :src="imageUrl" style="max-height: 6rem;" class="m-2">
                        </div>
                        <div class="md:flex md:items-center">
                            <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked">
                            <div class="md:w-2/3 flex justify-center md:justify-start">
                                <button class="shadow bg-primary hover:bg-purple-400 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded" type="button" @click="onPickFile">
                                    <div class="flex">
                                        Imagen <span class="material-icons text-secondary mx-1">attachment</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div class="flex items-center justify-center mb-6">
                            <button class="shadow mx-1 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click="isEdit = false;" style="background: #f56565">Cancelar</button>
                            <button class="shadow mx-1 bg-primary hover:bg-purple-400 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click="onSaveChanges">Editar</button>
                        </div>
                    </div>
                </CardModal>
                <CardModal :showing="isDel" v-on:close="isDel = false">
                    <div>
                        <h2 class="w-full text-center text-lg md:text-2xl"> Eliminar este Vestido?</h2>
                        <div class="w-full justify-center items-center flex">
                            <button class="shadow mx-1 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click="isDel = false;" style="background: #f56565">Cancelar</button>
                            <button class="shadow mx-1 bg-primary hover:bg-purple-400 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click="onDelete">Eliminar</button>
                        </div>
                    </div>
                </CardModal>
            </div>
        </div>
        <div v-else class="h-screen flex">
            <p class="my-auto mx-auto">Cargando...</p>
        </div>
    </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import CardModal from '@/components/shared/CardModal.vue'
export default {
    props: ['id'],
    components: {
        CardModal
    },
    data() {
        return {
            isEdit: false,
            isDel: false,
            talla: '',
            name: '',
            desc: '',
            coleccion: '',
            material: '',
            cantidad: 0,
            image: null,
            imageUrl: '',
            numerito: ''

        }
    },
    computed: {
        ...mapGetters(['getZapatoID', 'getLoading', 'loggedIn']),
        vestido() {
            return this.getZapatoID
        },
        autenticado() {
            return this.loggedIn
        },
        /*userStyle() {
            return {
                'background': this.getVestidoID.color
            }
        },*/
        cargando() {
            return this.getLoading
        },
        pidelo() {
            return 'https://wa.me/584128002579?text=' + 'Me%20encuentro%20interesado%20en%20el%20producto:%20' + 'ciosve.com/' + this.getZapatoID.producto + '/' + this.id
        },
        calculo(){
            if(!this.getZapatoID.cantidad){
                 if(this.numerito == '')
                    return this.cantidad
                else
                    return this.numerito
            }else{
                if(this.numerito == '')
                    return parseInt(this.getZapatoID.cantidad) + this.cantidad
                else
                    return this.numerito
            }
        }
    },
    methods: {
        ...mapActions(['ZapatoByID', 'editZapato', 'delZapato']),
        onSaveChanges() {
            /*if (this.name.trim() === '' || this.desc.trim() === '' ) {
                return
            }*/
            this.editZapato({
                id: this.id,
                name: this.name,
                desc: this.desc,
                image: this.image,
                cantidad: parseInt(this.calculo),
                antigua: parseInt(this.getZapatoID.cantidad)
            })
            this.isEdit = false
            this.cantidad = 0
        },
        onDelete() {
            this.delZapato(this.id)
            this.$router.push('/tienda')
        },
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked(event) {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf('.') <= 0) {
                return alert('Please add a valid file!')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.imageUrl = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        },
        sumar(){
            if(this.numerito != ''){
                this.numerito = parseInt(this.numerito) +1
                this.cantidad = 0
            }
            else{
                this.cantidad = this.cantidad +1
                this.numerito = ''
            }
        },
        restar(){
            if(this.numerito != ''){
                this.numerito = parseInt(this.numerito)-1
                this.cantidad = 0
            }
            else{
                this.cantidad = this.cantidad -1
                this.numerito = ''
            }
        }
    },
    created() {
        this.ZapatoByID(this.id)
    },
    beforeDestroy() {
        this.$store.commit('actualBelleza', null)
    },
}
</script>
<style scoped>
img {
    max-height: 38rem;
}

#form {
    max-height: 480px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@media only screen and (min-width: 750px) {
    form {
        max-height: 700px;
    }
}
</style>